import { DEGREES, RADIANS } from './constants';

export const CUSTOM_FN_PREFIX = 'ecosia_';

const halfCircle = 180;

const angleFunctions = {
  [DEGREES]: (value) => value / (halfCircle / Math.PI),
  [RADIANS]: (value) => value,
};

const reverseAngleFunctions = {
  [DEGREES]: (value) => value * (halfCircle / Math.PI),
  [RADIANS]: (value) => value,
};

/**
 * For the given angle units, creates a map of custom functions
 * with the `ecosia_` prefix. This allows us to have persistent
 * radians or degrees mode in the calculator.
 *
 * @param {Object} param0 { angleUnits = RADIANS|DEGREES }
 * @returns {Object} a mapping of custom function names to functions
 */
export const createCustomFunctions = ({ angleUnits = RADIANS }) => {
  const angle = angleFunctions[angleUnits];
  const reverseAngle = reverseAngleFunctions[angleUnits];

  return {
    [`${CUSTOM_FN_PREFIX}sin`]: (value) => Math.sin(angle(value)),
    [`${CUSTOM_FN_PREFIX}cos`]: (value) => Math.cos(angle(value)),
    [`${CUSTOM_FN_PREFIX}tan`]: (value) => Math.tan(angle(value)),
    [`${CUSTOM_FN_PREFIX}asin`]: (value) => reverseAngle(Math.asin(value)),
    [`${CUSTOM_FN_PREFIX}acos`]: (value) => reverseAngle(Math.acos(value)),
    [`${CUSTOM_FN_PREFIX}atan`]: (value) => reverseAngle(Math.atan(value)),
  };
};

const toAliasEntry = (alias) => [alias.replace(CUSTOM_FN_PREFIX, ''), alias];

/**
 * @param {Object} functions a mapping of custom function names to functions
 * @returns a mapping of overridden function names to custom function names
 */
export const createAliases = (functions) => Object
  .fromEntries(Object.keys(functions).map(toAliasEntry));
